export const ProMonthlyPlanID = 'pro-monthly';
export const ProYearlyPlanID = 'pro-yearly';
// created specifically for People Data Labs (61bad506e29f665c2b8b772d)
// see https://cannyhq.slack.com/archives/C017P1NFJ1X/p1748620461219159.
export const ProYearlyWithGoogleWorkspacePlanID = 'f224';

export const ProPlanIDs = [
  ProMonthlyPlanID,
  ProYearlyPlanID,
  ProYearlyWithGoogleWorkspacePlanID,
] as const;

export type ProPlanID = (typeof ProPlanIDs)[number];

export default (planID?: string | null): planID is ProPlanID => {
  if (!planID) {
    return false;
  }

  return ProPlanIDs.includes(planID as ProPlanID);
};
